<script lang="ts" setup>
import type { Product } from '~/types/searchTypes'
import buildCategoryUrl from '~/utils/filters/buildCategoryUrl'

const { product, categoryName } = defineProps<{
  product: Product
  categoryName?: string
  redirectUrl?: string
}>()

const categoryUrl = computed(() => {
  if (product.category_slug) {
    return buildCategoryUrl(product.category_slug)
  }

  if (product.quote_slug) {
    const parts = product.quote_slug.split('/')

    if (parts.length > 1) {
      const categorySlug = parts.slice(0, -1).join('/')

      return buildCategoryUrl(categorySlug)
    }

    return buildCategoryUrl(product.quote_slug)
  }

  return null
})
</script>

<template>
  <div class="category-product-card">
    <div class="category">
      <template v-if="categoryUrl">
        <p class="px-4 h-[3.5rem] lg:h-[4.5rem] overflow-hidden">
          <NuxtLink
            :to="categoryUrl"
            class="hover:text-brand-primary cursor-pointer transition no-underline hover:no-underline">
            {{ categoryName ?? product.category }} <i class="fa fa-arrow-right scale-75"></i>
          </NuxtLink>
        </p>
      </template>
      <template v-else>
        <p class="px-4 h-[3.5rem] lg:h-[4.5rem] overflow-hidden">{{ categoryName ?? product.category }}</p>
      </template>
    </div>
    <Card :product="product" :index="0" :redirect-url="redirectUrl" />
  </div>
</template>

<style lang="postcss" scoped>
.category-product-card {
  @apply flex flex-col h-full bg-white dark:bg-dmGray1;

  .category {
    @apply flex flex-col-reverse lg:flex-row lg:justify-between lg:mb-8;
    @apply font-bold text-xl lg:text-3xl flex-1 gap-2;
  }
}

.category-product-card {
  border-radius: theme('vars.borderRadiusLight');
  background-color: theme('colors.neutral7');
  padding: 1.25rem 0.625rem 0.625rem;

  :deep(.product-card) {
    background-color: theme('colors.white');
    @apply dark:bg-dmGray5;

    .title {
      @apply mb-2;
    }
  }
}
</style>
